module.exports = __webpack_public_path__ + "assets/img/button-report-org.56798f18.png";